var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"drop-trigger",class:['noselect'],on:{"click":function($event){return _vm.toggle()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }